// @flow
import { styled } from 'mz-ui-kit'
import { getScreenStyles } from '../../utils'

export const TryAgainButtonContainer = styled('div', {
  marginTop: '10px',
})

export const MethodContainer = styled('div', {
  marginBottom: '30px',
  ...getScreenStyles('xs', {
    marginBottom: '15px',
  }),
})

export const HeaderContainer = styled('div', {
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '7px 0',
  ...getScreenStyles('xs', {
    flexFlow: 'column nowrap',
    alignItems: 'flex-start',
  }),
})

export const HeaderLabel = styled('h3', {
  fontSize: '14px',
  margin: '5px 0',
  padding: 0,
})
